import { StateCreator } from "zustand";
import PublicPortalState from "@publicPortal/utils/InitialState";
import BuildingRegulationsSearchState from "@publicPortal/pages/search/BuildingRegulations/BuildingRegulationsSearchState";

const { initialSearchState: brInitialState, initialFilterState: brInitialFilter } = PublicPortalState.buildingRegulationsSearchState();

export interface BuildingRegulationsSearchSlice {
    buildingRegulationsSearch: BuildingRegulationsSearchState;
    setBuildingRegulationsSearch: (state: BuildingRegulationsSearchState) => void;
    updateBuildingRegulationsSearch: (partialState: Partial<BuildingRegulationsSearchState>) => void;
    updateBuildingRegulationsFilter: (partialFilter: Partial<BuildingRegulationsSearchState["filter"]>) => void;
    resetBuildingRegulationsFilter: () => void;
}

export const createBuildingRegulationsSearchSlice: StateCreator<BuildingRegulationsSearchSlice, [], [], BuildingRegulationsSearchSlice> = (set) => ({
    buildingRegulationsSearch: brInitialState,
    setBuildingRegulationsSearch: (state) => set({ buildingRegulationsSearch: state }),
    updateBuildingRegulationsSearch: (partialState) =>
        set((state) => ({ buildingRegulationsSearch: { ...state.buildingRegulationsSearch, ...partialState } })),
    updateBuildingRegulationsFilter: (partialFilter) =>
        set((state) => ({
            buildingRegulationsSearch: { ...state.buildingRegulationsSearch, filter: { ...state.buildingRegulationsSearch.filter, ...partialFilter } },
        })),
    resetBuildingRegulationsFilter: () =>
        set((state) => ({ buildingRegulationsSearch: { ...state.buildingRegulationsSearch, filter: { ...brInitialFilter } } })),
});

